import React, { useState } from 'react';
import SuperAdminSidebar from './SuperAdminSidebar';
import SuperAdminNav from './SuperAdminNav';

const SuperAdminLayout = ({ children, onNavigate, userInfo, activePage, pageTitle, icon }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          -webkit-font-smoothing: antialiased;
          overflow-x: hidden;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(2deg); }
        }

        @keyframes glow {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes shimmer {
          0% { background-position: -1000px 0; }
          100% { background-position: 1000px 0; }
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        .dashboard-container {
          display: flex;
          height: 100vh;
          background: #ffffff;
          position: relative;
          overflow: hidden;
        }

        .sidebar {
          position: fixed;
          top: 0;
          left: 0;
          bottom: 0;
          width: 300px;
          background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(242,242,242,0.98) 100%);
          backdrop-filter: blur(30px);
          border-right: 2px solid rgba(82,171,152,0.2);
          transform: translateX(-100%);
          transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          z-index: 100;
          display: flex;
          flex-direction: column;
          box-shadow: 8px 0 40px rgba(43,103,119,0.15);
        }

        .sidebar.open {
          transform: translateX(0);
        }

        .sidebar-header {
          padding: 36px 28px;
          background: linear-gradient(135deg, rgba(43,103,119,0.05) 0%, rgba(82,171,152,0.05) 100%);
          border-bottom: 2px solid rgba(82,171,152,0.15);
          position: relative;
          overflow: hidden;
        }

        .sidebar-header::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(82,171,152,0.15), transparent);
          animation: shimmer 4s infinite;
        }

        .sidebar-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 24px;
          position: relative;
          z-index: 1;
        }

        .close-btn {
          background: rgba(43,103,119,0.08);
          border: 1.5px solid rgba(82,171,152,0.25);
          cursor: pointer;
          font-size: 20px;
          color: #2b6777;
          width: 38px;
          height: 38px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s;
        }

        .close-btn:hover {
          background: rgba(43,103,119,0.15);
          border-color: #52ab98;
          transform: rotate(90deg);
        }

        .user-info-sidebar {
          display: flex;
          align-items: center;
          gap: 14px;
          position: relative;
          z-index: 1;
        }

        .user-avatar-sidebar {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
          font-size: 22px;
          color: white;
          box-shadow: 0 6px 24px rgba(43,103,119,0.3);
          border: 3px solid rgba(255, 255, 255, 0.5);
        }

        .user-details-sidebar {
          flex: 1;
        }

        .user-name-sidebar {
          font-size: 16px;
          font-weight: 800;
          color: #2b6777;
          margin-bottom: 4px;
        }

        .user-role-sidebar {
          font-size: 13px;
          color: #52ab98;
          font-weight: 600;
        }

        .sidebar-nav {
          flex: 1;
          padding: 28px 20px;
          overflow-y: auto;
        }

        .sidebar-nav::-webkit-scrollbar {
          width: 6px;
        }

        .sidebar-nav::-webkit-scrollbar-track {
          background: rgba(82,171,152,0.08);
        }

        .sidebar-nav::-webkit-scrollbar-thumb {
          background: rgba(82,171,152,0.3);
          border-radius: 3px;
        }

        .nav-section {
          margin-bottom: 32px;
        }

        .nav-label {
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: rgba(43,103,119,0.5);
          margin-bottom: 12px;
          padding-left: 18px;
        }

        .menu-item {
          position: relative;
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 16px 18px;
          margin-bottom: 10px;
          cursor: pointer;
          color: #2b6777;
          font-size: 15px;
          font-weight: 600;
          border-radius: 14px;
          transition: all 0.3s;
          overflow: hidden;
        }

        .menu-glow {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(43,103,119,0.08) 0%, rgba(82,171,152,0.08) 100%);
          opacity: 0;
          transition: opacity 0.3s;
        }

        .menu-item:hover {
          color: #52ab98;
          background: rgba(82,171,152,0.1);
          transform: translateX(6px);
          box-shadow: 0 4px 16px rgba(82,171,152,0.15);
        }

        .menu-item:hover .menu-glow {
          opacity: 1;
        }

        .menu-item-active {
          background: linear-gradient(135deg, rgba(43,103,119,0.15) 0%, rgba(82,171,152,0.15) 100%);
          color: #2b6777;
          box-shadow: 0 6px 20px rgba(82,171,152,0.2);
          font-weight: 700;
        }

        .menu-item-active .menu-glow {
          opacity: 1;
          animation: glow 2s ease-in-out infinite;
        }

        .menu-icon {
          font-size: 22px;
          position: relative;
          z-index: 1;
        }

        .menu-label {
          position: relative;
          z-index: 1;
        }

        .logout-section {
          padding: 20px;
          border-top: 2px solid rgba(82,171,152,0.15);
        }

        .logout-btn {
          width: 100%;
          padding: 16px 20px;
          background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
          color: white;
          border: none;
          border-radius: 14px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: all 0.3s;
          box-shadow: 0 6px 24px rgba(43,103,119,0.3);
        }

        .logout-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 35px rgba(43,103,119,0.4);
        }

        .main-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          width: 100%;
          position: relative;
          z-index: 1;
        }

        .top-header {
          background: #ffffff;
          padding: 32px 32px; /* Adjusted padding to be smaller if title is present */
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid rgba(82,171,152,0.12);
          position: relative;
          box-shadow: 0 2px 8px rgba(43,103,119,0.06);
          min-height: 100px;
        }

        .top-header::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #2b6777 0%, #52ab98 100%);
        }

        .header-left {
          display: flex;
          align-items: center;
          gap: 24px;
          flex: 1;
        }

        .menu-toggle {
          background: linear-gradient(135deg, rgba(43,103,119,0.1) 0%, rgba(82,171,152,0.1) 100%);
          border: 2px solid rgba(82,171,152,0.25);
          cursor: pointer;
          font-size: 26px;
          color: #2b6777;
          width: 52px;
          height: 52px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s;
          box-shadow: 0 4px 20px rgba(43,103,119,0.15);
        }

        .menu-toggle:hover {
          transform: scale(1.05);
          box-shadow: 0 6px 30px rgba(43,103,119,0.25);
          background: linear-gradient(135deg, rgba(43,103,119,0.15) 0%, rgba(82,171,152,0.15) 100%);
        }

        .header-title-section {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .header-greeting {
          font-size: 18px;
          color: #52ab98;
          font-weight: 600;
        }

        .header-name {
          font-size: 28px;
          font-weight: 900;
          background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .header-right {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .user-avatar-header {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
          font-size: 20px;
          color: white;
          cursor: pointer;
          border: 3px solid rgba(82,171,152,0.3);
          transition: all 0.3s;
          box-shadow: 0 6px 24px rgba(43,103,119,0.3);
        }

        .user-avatar-header:hover {
          transform: scale(1.1);
          box-shadow: 0 8px 32px rgba(43,103,119,0.5);
        }

        .content-wrapper {
          flex: 1;
          overflow-y: auto;
          padding: 40px 28px;
        }

        .content-wrapper::-webkit-scrollbar {
          width: 8px;
        }

        .content-wrapper::-webkit-scrollbar-track {
          background: rgba(82,171,152,0.08);
        }

        .content-wrapper::-webkit-scrollbar-thumb {
          background: rgba(82,171,152,0.3);
          border-radius: 4px;
        }

        .content-area {
          max-width: 1500px;
          margin: 0 auto;
          animation: slideIn 0.6s ease-out;
        }

        @media (max-width: 1024px) {
            .sidebar { transform: translateX(-100%); }
            .sidebar.open { transform: translateX(0); }
            .main-content { margin-left: 0; width: 100%; }
            .top-header { padding: 20px; }
            .menu-toggle { display: flex; } /* Ensure visible on mobile */
        }
        
        @media (min-width: 1025px) {
            .sidebar { transform: translateX(0); } /* Always visible on desktop */
            .main-content { margin-left: 300px; width: calc(100% - 300px); }
            .menu-toggle { display: none; } /* Hide on desktop as sidebar is persistent */
        }
      `}</style>

            <div className="dashboard-container">
                <SuperAdminSidebar
                    isOpen={sidebarOpen}
                    onClose={() => setSidebarOpen(false)}
                    userInfo={userInfo}
                    onNavigate={onNavigate}
                    activePage={activePage}
                />

                <div className="main-content">
                    <SuperAdminNav
                        setSidebarOpen={setSidebarOpen}
                        userInfo={userInfo}
                        pageTitle={pageTitle}
                        icon={icon}

                    />
                    <div className="content-wrapper">
                        <div className="content-area">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SuperAdminLayout;
